import useAPIHelpers, { updateCognitoUserAttribute } from "./useAPIHelpers";
export { useAPIHelpers, updateCognitoUserAttribute };

export function hasAgreementByTypeAndStatus(userAgreements = [], type, status) {
  return userAgreements.items.some((item) => {
    return item.agreement.type === type && item.agreement.status === status && item.isGranted === true;
  });
}
